import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { AlertCircle, Info, AlertTriangle, X } from "lucide-react";

type Ann = { id: string; title: string; message: string; severity: string };

export const AnnouncementBanner = () => {
  const [items, setItems] = useState<Ann[]>([]);
  const [dismissed, setDismissed] = useState<string[]>(() => {
    try { return JSON.parse(localStorage.getItem("dismissedAnnouncements") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    supabase.from("system_announcements").select("id,title,message,severity")
      .eq("is_active", true)
      .order("created_at", { ascending: false })
      .then(({ data }) => setItems((data as Ann[]) || []));
  }, []);

  const dismiss = (id: string) => {
    const next = [...dismissed, id];
    setDismissed(next);
    localStorage.setItem("dismissedAnnouncements", JSON.stringify(next));
  };

  const visible = items.filter((i) => !dismissed.includes(i.id));
  if (visible.length === 0) return null;

  const styles: Record<string, string> = {
    info: "bg-primary/10 text-foreground border-primary/30",
    warning: "bg-yellow-500/10 text-foreground border-yellow-500/40",
    critical: "bg-destructive/10 text-foreground border-destructive/40",
  };
  const Icon = (s: string) => s === "critical" ? AlertCircle : s === "warning" ? AlertTriangle : Info;

  return (
    <div className="space-y-2 p-2">
      {visible.map((a) => {
        const I = Icon(a.severity);
        return (
          <div key={a.id} className={`flex items-start gap-3 border rounded-md px-3 py-2 ${styles[a.severity] || styles.info}`}>
            <I className="h-4 w-4 mt-0.5 flex-shrink-0" />
            <div className="flex-1 text-sm">
              <strong>{a.title}</strong> — {a.message}
            </div>
            <button onClick={() => dismiss(a.id)} className="opacity-60 hover:opacity-100">
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
};
